import React, { useCallback, useEffect } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { USP_SLIDES_DATA } from "@/lib/utils";

const UspBlogs: React.FC = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      skipSnaps: false,
      breakpoints: {
        "(min-width: 768px)": { slidesToScroll: 1, align: "start" },
        "(min-width: 1024px)": { slidesToScroll: 1, align: "start" },
        "(min-width: 1280px)": { slidesToScroll: 1, align: "start" },
      },
    },
    [Autoplay({ delay: 2500, stopOnInteraction: false })],
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
  }, [emblaApi]);

  return (
    <>
      <div className="bg-white w-full md:py-[50px] py-8 relative md:bg-bottom bg-center square_grid_bg bg-repeat bg-cover bg-[length:100% 100%] relative">
        <div
          className="lg:container mx-auto h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 relative lg:block hidden"
          id="alumni2"
        >
          <div>
            <div className="text-center">
              <h2 className="text-2xl lg:text-[36px] md:text-[60px] mb-3 lg:leading-[1.3] md:leading-[3rem] leading-[1.8rem] text-[#000] font-semibold text-center inline-block mx-auto px-[4px] md:mb-[30px]">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                  Blog
                </span>
              </h2>
            </div>
            <div className="flex 2xl:justify-between xl:justify-center lg:justify-between flex-nowrap overflow-y-auto">
              <div className="overflow-hidden w-full py-2" ref={emblaRef}>
                <div className="flex">
                  {USP_SLIDES_DATA.map((slide, index) => (
                    <div key={index} className="flex-none w-1/3 px-2">
                      <a
                        href={slide.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white rounded-[16px] p-3 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] block mb-2"
                      >
                        <Image
                          src={slide.imgSrc}
                          alt={slide.imgAlt}
                          className="mx-auto md:w-[420px] rounded-[8px]"
                          width={455}
                          height={300}
                          priority
                        />
                        <div className="pt-4">
                          <h3 className="text-[22px] text-[#171717] font-semibold leading-[1.2] line-clamp-2">
                            {slide.title}
                          </h3>
                          <span className="text-[12px] text-[#606060]">
                            {slide.readTime}
                          </span>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>{" "}
            <div className="text-center mx-auto md:mt-8 mt-6">
              <a
                className=" flex justify-center"
                href="/blog/accounting"
                target="_blank"
              >
                <div className="grp_btn flex justify-center items-center">
                  <Image
                    priority
                    src="/arrow2.png"
                    alt="arrow image"
                    className="new_arrow "
                    width={45}
                    height={45}
                  />
                  <p className="new__discover_btn font-medium inline-block !px-[40px]">
                    View All
                  </p>
                </div>
              </a>
            </div>
          </div>

          <div
            onClick={scrollPrev}
            className="absolute 2xl:left-[-50px] xl:left-[-5px] lg:left-[5px] left-[0px] top-[40%] cursor-pointer"
          >
            <Image
              src="/cpa/left_arrow.png"
              alt="Special Offer"
              className="mx-auto my-2 xl:w-[43px] md:w-[28px]"
              width={43}
              height={43}
              priority
            />
          </div>
          <div
            onClick={scrollNext}
            className="absolute 2xl:right-[-50px] xl:right-[5px] lg:right-[5px] right-[0px] top-[40%] cursor-pointer"
          >
            <Image
              src="/cpa/right_arrow.png"
              alt="Special Offer"
              className="mx-auto my-2 xl:w-[43px] md:w-[28px]"
              width={43}
              height={43}
              priority
            />
          </div>
        </div>

        <Image
          src="/images/accounting/usp/Blog-mount.png"
          alt="Special Offer"
          className="md:hidden block mx-auto absolute bottom-0 left-0"
          width={335}
          height={361}
          priority
        />
        <div
          className="lg:container mx-auto h-full 2xl:px-0 xl:px-10 lg:px-6 px_5 relative lg:hidden block"
          id="alumni2"
        >
          <div className="text-center">
            <h2 className="text-2xl lg:text-[64px] md:text-[38px] mb-3 font-semibold lg:leading-[1.3] md:leading-[3rem] leading-[1.8rem] text-black text-center border-[#ca7216] md:border-b-[4px] border-b-2 bg-no-repeat inline-block mx-auto px-[4px]">
              Blog
            </h2>
          </div>
          <div
            className="lg:pb-20 lg:pt-0 md:py-6 md:pb-10 lg:px-0 md:px-5 px-3 pt-0 pb-14"
            id="how"
          >
            <div className="flex justify-between flex-nowrap overflow-y-auto p-3">
              {USP_SLIDES_DATA.slice(0, 3).map((blog, index) => (
                <a
                  key={index}
                  href={blog.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white rounded-[16px] p-2 !min-w-[280px] mr-6 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] block"
                >
                  <Image
                    src={blog.imgSrc}
                    alt={blog.imgAlt}
                    className="mx-auto md:w-[420px]"
                    width={455}
                    height={300}
                    priority
                  />
                  <div className="pt-4">
                    <p className="md:text-[24px] text-[17px] text-[#171717] font-semibold leading-[1.2] line-clamp-2">
                      {blog.title}
                    </p>
                    <span className="text-[12px] text-[#606060]">
                      {blog.readTime}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <a
            className="grp_btn flex justify-start items-center w-[192px] mx-auto"
            href="/blog/accounting"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="w-[43px] h-[40px] rounded-full flex justify-center items-center">
              <Image
                priority
                src="/images/accounting/arrow.png"
                alt="arrow image"
                className="new_arrow"
                width={48}
                height={48}
              />
            </div>
            <div className="out_btn font-normal inline-block">
              <p className="new_btn !bg-[#3e86f2] py-[8px]">View All</p>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default UspBlogs;
